import { render } from "./PDFViewerNative.vue?vue&type=template&id=2e9cf5c3&scoped=true"
import script from "./PDFViewerNative.vue?vue&type=script&lang=js"
export * from "./PDFViewerNative.vue?vue&type=script&lang=js"

import "./PDFViewerNative.vue?vue&type=style&index=0&id=2e9cf5c3&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e9cf5c3"]])

export default __exports__